export default __webpack_public_path__ + "b28ef4ceb103bb5b41a3fab899f378d9.jpg";